module.exports = __webpack_public_path__ + "static/media/linkedin-payment-3-en.90f84d63.png";